import { Route, Routes } from "react-router-dom";
import "./index.css";

import Landing from "./Landing";
import Result from "./Result";
import BarcodeScanner from "./Scanner";
import BarcodeScanner2 from "./Scanner2";
import BannedList from "./BannedList";
import UnknownList from "./UnknownList";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/result/:code" element={<Result />} />
      <Route path="/scanner" element={<BarcodeScanner />} />
      <Route path="/scanner2" element={<BarcodeScanner2 />} />
      <Route path="/banned-list" element={<BannedList />} />
      <Route path="/unknown-list" element={<UnknownList />} />
    </Routes>
  );
}

export default App;
